import request from '@/utils/request';

//短信模板列表
export function getMmsList(values) {
  return request('/mms/querySmsTemplateList', {
    method: 'POST',
    data: values,
  });
}
//删除短息模板列表
export function deleteTempMsg(values) {
  return request('/mms/deleteTempMsg', {
    method: 'POST',
    data: values,
  });
}
